module.exports = __webpack_public_path__ + "static/media/boy-3.0ebe6369.svg";